import { render, staticRenderFns } from "./PlayerAdditional.vue?vue&type=template&id=c834d5fc&scoped=true&"
import script from "./PlayerAdditional.vue?vue&type=script&lang=js&"
export * from "./PlayerAdditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c834d5fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/usr/src/regapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VFlex,VForm,VLayout,VRadio,VRadioGroup,VTextField})
